<template>
  <div class="max-w-md mx-auto">
    <h1 class="text-2xl font-bold text-center text-gray-900 mb-6">注册账号</h1>
    
    <div class="bg-white p-6 rounded-lg shadow-md">
      <form @submit.prevent="register">
        <div v-if="error" class="mb-4 p-3 bg-red-100 text-red-700 rounded text-sm">
          {{ error }}
        </div>
        
        <div class="mb-4">
          <label for="username" class="block text-sm font-medium text-gray-700 mb-1">用户名</label>
          <input 
            v-model="form.username" 
            type="text" 
            id="username" 
            required 
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder="设置一个用户名"
          />
        </div>
        
        <div class="mb-4">
          <label for="email" class="block text-sm font-medium text-gray-700 mb-1">邮箱</label>
          <input 
            v-model="form.email" 
            type="email" 
            id="email" 
            required 
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder="example@example.com"
          />
        </div>
        
        <div class="mb-6">
          <label for="password" class="block text-sm font-medium text-gray-700 mb-1">密码</label>
          <input 
            v-model="form.password" 
            type="password" 
            id="password" 
            required 
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder="设置一个密码"
          />
        </div>
        
        <button 
          type="submit" 
          :disabled="loading"
          class="w-full py-2 px-4 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:bg-blue-300"
        >
          <span v-if="loading">正在注册...</span>
          <span v-else>注册</span>
        </button>
      </form>
      
      <p class="mt-4 text-center text-sm text-gray-600">
        已有账号？
        <router-link to="/login" class="text-blue-600 hover:underline">
          立即登录
        </router-link>
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue';
import { useAuthStore } from '../stores/auth';
import { useRouter } from 'vue-router';

const authStore = useAuthStore();
const router = useRouter();

const error = ref('');
const loading = ref(false);
const form = reactive({
  username: '',
  email: '',
  password: ''
});

const register = async () => {
  error.value = '';
  loading.value = true;
  
  try {
    await authStore.register(form);
    router.push('/');
  } catch (err) {
    error.value = err.response?.data?.message || '注册失败，请稍后再试';
  } finally {
    loading.value = false;
  }
};
</script>